import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@app/material/material.module';

import { ImageUploadComponent } from './image-upload.component';

@NgModule({
  declarations: [ImageUploadComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [ImageUploadComponent]
})
export class ImageUploadModule {}
